import { render } from "./AppSubHeader.vue?vue&type=template&id=21d8f1f2"
import script from "./AppSubHeader.vue?vue&type=script&lang=js"
export * from "./AppSubHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__